/**
 * Dados estruturados (schema.org) da página, em JSON-LD.
 *
 * Renderizado ao lado do `SeoMetaTags`, e reaproveitando o mesmo cálculo de
 * canônica e de imagem — o grafo precisa apontar para exatamente a mesma URL e
 * a mesma foto que as meta tags, senão o buscador vê duas versões da página.
 *
 * OS 0007/2026, Cap. IV, I.
 */

import config from '@plone/volto/registry';
import React from 'react';
import { useSelector } from 'react-redux';

import JsonLd from './JsonLd';
import { buildSeoMetadata } from './metadata';
import { buildStructuredData } from './structuredData';

interface Props {
  content: any;
  canonicalPath?: string;
}

export const SeoStructuredData: React.FC<Props> = ({
  content,
  canonicalPath,
}) => {
  const siteData = useSelector((state: any) => state.site?.data);
  const breadcrumbs = useSelector((state: any) => state.breadcrumbs?.items);

  const meta = buildSeoMetadata(content, {
    siteName: siteData?.['plone.site_title'],
    canonicalPath,
    fallbackImageUrl: (config.settings as any)?.mpfSeo?.fallbackImageUrl,
  });

  if (!meta) return null;

  const publicUrl = ((config.settings as any)?.publicURL ?? '').replace(
    /\/+$/,
    '',
  );

  const graph = buildStructuredData({
    content,
    siteName: meta.siteName,
    canonicalUrl: meta.canonicalUrl,
    image: meta.image,
    breadcrumbs,
    // A trilha vinda da API não inclui a raiz; o rótulo é o mesmo que o
    // componente visual de breadcrumb usa.
    homeLabel: 'Início',
    isSiteRoot: meta.canonicalUrl === `${publicUrl}/`,
    publicUrl,
    logoUrl: siteData?.['plone.site_logo'],
  });

  return <JsonLd graph={graph} />;
};

export default SeoStructuredData;
